import { render, staticRenderFns } from "./NewBranchReport.vue?vue&type=template&id=795c3e12&scoped=true"
import script from "./NewBranchReport.vue?vue&type=script&lang=js"
export * from "./NewBranchReport.vue?vue&type=script&lang=js"
import style0 from "./NewBranchReport.vue?vue&type=style&index=0&id=795c3e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c3e12",
  null
  
)

export default component.exports